<template>
  <div :style="brandStyle">
    <p class="title">合作伙伴</p>
    <ul class="brand-img">
      <template v-if="brandStyle === 'background:rgba(247,248,248,1);'">
        <li v-for="(item, index) in imgArr" :key="index">
          <img :src="item.url" :class="item.class" alt="">
        </li>
      </template>
      <template v-else-if="brandStyle === 'background:rbga(255,255,255,1);'">
        <li v-for="(item, index) in imgArrWhite" :key="index">
          <img :src="item.url" :class="item.class" alt="">
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import p1 from '../assets/images/brand/01.png'
import p2 from '../assets/images/brand/02.png'
import p3 from '../assets/images/brand/03.png'
import p4 from '../assets/images/brand/04.png'
import p5 from '../assets/images/brand/05.png'
import p6 from '../assets/images/brand/06.png'
import p7 from '../assets/images/brand/07.png'
import p8 from '../assets/images/brand/08.png'
import p9 from '../assets/images/brand/09.png'
import p10 from '../assets/images/brand/010.png'
import p11 from '../assets/images/brand/011.png'
import p12 from '../assets/images/brand/012.png'
import p13 from '../assets/images/brand/013.png'
import p14 from '../assets/images/brand/014.png'
import p15 from '../assets/images/brand/015.png'
import p01 from '../assets/images/brand/001.png'
import p02 from '../assets/images/brand/002.png'
import p03 from '../assets/images/brand/003.png'
import p04 from '../assets/images/brand/004.png'
import p05 from '../assets/images/brand/005.png'
import p06 from '../assets/images/brand/006.png'
import p07 from '../assets/images/brand/007.png'
import p08 from '../assets/images/brand/008.png'
import p09 from '../assets/images/brand/009.png'
import p010 from '../assets/images/brand/0010.png'
import p011 from '../assets/images/brand/0011.png'
import p012 from '../assets/images/brand/0012.png'
import p013 from '../assets/images/brand/0013.png'
import p014 from '../assets/images/brand/0014.png'
import p015 from '../assets/images/brand/0015.png'

export default {
  data () {
    return {
      imgArr: [
        {'url': p1},
        {'url': p2},
        {'url': p3},
        {'url': p4},
        {'url': p5},
        {'url': p6},
        {'url': p7},
        {'url': p8},
        {'url': p9},
        {'url': p10},
        {'url': p11},
        {'url': p12},
        {'url': p13},
        {'url': p14},
        {'url': p15}
      ],
      imgArrWhite: [
        {'url': p01},
        {'url': p02},
        {'url': p03},
        {'url': p04},
        {'url': p05},
        {'url': p06},
        {'url': p07},
        {'url': p08},
        {'url': p09},
        {'url': p010},
        {'url': p011},
        {'url': p012},
        {'url': p013},
        {'url': p014},
        {'url': p015}
      ]
    }
  },
  props: {
    brandStyle: {
      type: String,
      default: 'background:rgba(247,248,248,1);'
    }
  }
}
</script>

<style scoped>
  .brand-img{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 50px 450px;
  }
  .brand-img>li{
    width: 182px;
    height: 101px;
    border: 1px solid #ccc;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .brand-img>li img{
    width: 90%;
  }
  .title{
    padding-top: 114px;
    padding-bottom: 30px;
    font-size:34px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:61px;
    color:rgba(51,51,51,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/brand.vue